export default "__VITE_ASSET__b84c856a__"